import { createContext } from "react";
import type { createConfigurationApi, createFileApi } from "@repo/services";

export type ConfigurationApi = ReturnType<typeof createConfigurationApi>;
export type FileApi = ReturnType<typeof createFileApi>;

export type SharedApiContextValue = {
  configurationApi: ConfigurationApi;
  fileApi: FileApi;
};

export const SharedApiContext = createContext<SharedApiContextValue | null>(null);

